import { action } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { Deeplink, DeeplinkURL } from '@root/entities/deeplinking'
import { joinedInviteCodeAtom } from '@root/entities/referral'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { DEMO_MODE, PlatformUtil } from '@root/shared'
import { apiRequest } from '@root/shared/api'
import { showSnackbarAction } from '@root/shared/ui-kit'

import type { GoogleAuthAction } from '../model'

/**
 * If action is not provided, it's either login or register
 */
export const redirectToGoogleAction = action(
  async (ctx, action?: GoogleAuthAction) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    if (DEMO_MODE) {
      window.location.replace(
        `${window.location.origin}/google-auth?code=google_demo_code&state=${action}`,
      )
      return
    }
    const inviteCode = ctx.get(joinedInviteCodeAtom)

    const redirectURL = DeeplinkURL.getURLFor(
      'GoogleAuth',
      // code and state will be generated by google
      [
        new Deeplink.GoogleAuth({
          code: undefined,
          state: undefined,
        }),
      ],
    ).toString()

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.google.googleRedirectCreate, [
        {
          redirectUri: redirectURL,
          action,
          referralCode: inviteCode,
        },
      ]),
    )

    if (Result.isFailure(result)) {
      showSnackbarAction(ctx, {
        text: i18next.t('common.something-went-wrong'),
        intent: 'error',
      })
      return
    }

    PlatformUtil.openLink(result.success.authUrl)
  },
  'redirectToGoogleAction',
)
